export default {
  data () {
    return {
      showModalBroker: false
    }
  },
  methods: {
    controlarModalBroker () {
      const isStepperPolitica = this.$options.name === 'StepperPoliticaVendas'
      const isCadastro = this.$options.name === 'Cadastro'

      if (!this.pedido || !this.pedido.id_produto) {
        return
      }

      let deveMostrar = false

      if (isStepperPolitica) {
        deveMostrar = this.$session.get('broker_politica_vendas') || false
      } else if (isCadastro) {
        deveMostrar = this.$session.get('broker_fluxo_vendas_comum') || false
      }

      if (deveMostrar) {
        this.showModalBroker = true
      }
    }
  },
  mounted () {
    this.controlarModalBroker()
  }
}
